import { Observable, map } from "rxjs";
import HttpService from "./HttpService"; 
import { url } from "./APIEndPoints";  
import { buildParamString, IAPIResponse } from "@mindmemobile/mm-shared-global";
import { CreateMembershipResponseModel } from "../models/MembershipAPIResponseModels";
import { IAPICreateUpdateMembershipModel, IAPIGetMembershipForEditResponse } from "../interfaces/IAPIMembershipModels";
import { IAPIProductReferenceInPurchaseResponse } from "../interfaces/IAPIProductModels";

class MembershipService {
  private httpService: HttpService;

  constructor() {
    this.httpService = new HttpService(
      undefined,
      `${process.env.REACT_APP_API_KEY}`,
      process.env.REACT_APP_API_BASE_URL
    );
  }

  save(
    data: IAPICreateUpdateMembershipModel
  ): Observable<CreateMembershipResponseModel> {
    return this.httpService
      .post<
        IAPIResponse<CreateMembershipResponseModel>
      >(url.createMembershp, data)
      .pipe(map((result) => new CreateMembershipResponseModel(result.result)));
  }

  update(data: IAPICreateUpdateMembershipModel): Observable<boolean> {
    return this.httpService
      .put<IAPIResponse<boolean>>(url.udpateMembership, data)
      .pipe(map((result) => result.result));
  }

  getMembership(
    accountId: string,
    membershipId: string
  ): Observable<IAPIResponse<IAPIGetMembershipForEditResponse>> {
    const params: string = buildParamString({
      accountId: accountId,
      membershipId: membershipId,
    });

    return this.httpService.get<IAPIResponse<IAPIGetMembershipForEditResponse>>(
      url.getMembership,
      params
    );
  }

  updateStatus(
    accountId: string,
    id: string,
    isActive: boolean
  ): Observable<IAPIResponse<boolean>> {
    const request = {
      accountId: accountId,
      id: id,
      isActive: isActive,
    };

    return this.httpService.put<IAPIResponse<boolean>>(
      url.membershipStatusUpdate,
      request
    );
  }

  deleteItem(accountId: string, itemId: string) {
    const request = {
      accountId: accountId,
      itemId: itemId,
    };

    return this.httpService.put<IAPIResponse<boolean>>(
      url.deleteMembership,
      request
    );
  }

  getMembershipReferenceInPurchases(
    accountId: string,
    id: string
  ): Observable<IAPIResponse<IAPIProductReferenceInPurchaseResponse>> {
    const params: string = buildParamString({
      accountId: accountId,
      id: id,
    });

    return this.httpService.get<
      IAPIResponse<IAPIProductReferenceInPurchaseResponse>
    >(url.getMembershipReferenceInPurchase, params);
  }
}

export default new MembershipService();
